<p-sidebar [(visible)]="visible" position="top" [baseZIndex]="10000" styleClass="p-sidebar-lg">
  <h4 class="n1ql-title">N1QL Statement Editor</h4>
  <ng-content></ng-content>
  <div class="footer drawer-footer">
    <button class="btn btn-sm btn-primary" (click)="toggleSlider()">Close</button>
  </div>
</p-sidebar>
